/**
 * Shell geometry and breakpoints shared between JS and CSS.
 *
 * These mirror the --sider-w / --topbar-h custom properties in
 * src/theme/tokens.css. Before this existed the same numbers were
 * written out in NavSide.jsx, style.css and the header padding rules,
 * and they drifted apart. Import from here instead of retyping a pixel
 * value.
 */

export const SIDER_WIDTH = 268;
export const TOPBAR_HEIGHT = 64;

/** Below this the sidebar stops being a rail and becomes a drawer. */
export const MOBILE_BREAKPOINT = 992;

/** Below this tables stop being tables and become stacked cards. */
export const TABLE_CARD_BREAKPOINT = 768;

export const isMobileViewport = () =>
  typeof window !== "undefined" && window.innerWidth < MOBILE_BREAKPOINT;

export const isCompactViewport = () =>
  typeof window !== "undefined" && window.innerWidth < TABLE_CARD_BREAKPOINT;
